@if (component) {
<div class="component-summary">
	{{component.type | componentname}}: {{component.name}}
	@if (component.state) {
	<span>
		&nbsp; HI: {{component.state.hi | number : ".5-5" }}&nbsp; Filtered HI:
		{{component.state.filtered_hi | number : ".5-5"}}
		@if (component.state.rul) {
		<span>&nbsp; RUL: {{component.state.rul | number : ".1-1"}}</span>
		}
	</span>
	}
</div>
}
@if (component) {
<div class="bubble-tabs">
	<a class="bubble-tab" routerLink="hi" routerLinkActive="selected">HI Trend</a>
	<a class="bubble-tab" routerLink="ci" routerLinkActive="selected">CI Trend</a>
	@if (component.type !== 'engine' && component.type !== 'flutter' && component.type !== 'tracker') {
	<a class="bubble-tab" routerLink="detail" routerLinkActive="selected">Component Detail</a>
	}
	<a class="bubble-tab" routerLink="comparison" routerLinkActive="selected">Fleet Comparison</a>
</div>
}
<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>